import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { lastValueFrom } from 'rxjs';
import { AbstractRtpAccountActivityCorrespondentService } from '../abstraction/abstract.account-activity-correspondent.service';

@Injectable({
  providedIn: 'root',
})
export class MockRtpAccountActivityCorrespondentService extends AbstractRtpAccountActivityCorrespondentService {
  private tableFilterJson = 'assets/mocks/rtp/accountactivity/correspondent/tableFilter.json';

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }
}
